


























































import { IconSize } from '@getaccept/lib-ui';
import type { SelectEntity } from '@getaccept/lib-shared/src/select-entity/types/select-entity';
import { ResourceType } from '@getaccept/lib-shared/src/resources/types/enum/resource-type';
import { isWindowSize } from '@getaccept/lib-shared/src/helpers/window-size.helper';
import { WindowSize } from '@getaccept/lib-shared/src/enums/window-size';
import { PathName } from '@getaccept/lib-shared/src/enums/PathNames';
import { ModuleName } from '@getaccept/lib-shared/src/entity/app-modules/enums/app-module';
import { defineComponent, computed, ref } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import useBreakpoints from '@getaccept/lib-shared/src/composables/breakpoints.composable';
import Search from '../search/components/Search.vue';
import { useSessionStore } from '../../session/store/session.store';
import { languageLoaded } from '../../lang';
import router from '../../router/router';
import { useAppMode } from '../../composables/app-mode.composable';
import { CreateDocumentConstants } from '../constants/create-documents';
import { useModulesStore } from '../../modules/store/modules.store';
import { useNavigationMenuStore } from '../store/navigation-menu.store';
import { useSubscriptionStore } from '../../subscription/store/subscription.store';
import { useAssemblerStore } from '../../document-edit/assembler/store/assembler.store';
import CreateDocumentButton from './CreateDocumentButton.vue';
import ProfileDropdown from './ProfileDropdown.vue';
import SupportIntercom from './SupportIntercom.vue';
import GlobalTopbarContainer from './GlobalTopbarContainer.vue';
import MyDocumentsValidationModal from './MyDocumentsValidationModal.vue';

export default defineComponent({
  name: 'GlobalTopbar',
  components: {
    GlobalTopbarContainer,
    Search,
    SupportIntercom,
    ProfileDropdown,
    CreateDocumentButton,
    MyDocumentsValidationModal,
  },
  setup(_, { emit }) {
    const sessionStore = useSessionStore();
    const { isInactiveSubscription } = storeToRefs(useSubscriptionStore());
    const { isContractRoomModuleActive } = storeToRefs(useModulesStore());
    const { isOpen: isGlobalNavMenuOpen } = storeToRefs(useNavigationMenuStore());
    const { toggle: toggleGlobalNavMenu, setOpen: setGlobalNavMenuOpen } = useNavigationMenuStore();

    const { isMediumScreenAndDown } = useBreakpoints();
    const { appMode } = useAppMode();

    const showValidateMyDocumentsEmailModal = ref(false);

    const documentOptions = computed(() =>
      CreateDocumentConstants.documentTypes().filter(({ displayMode }) =>
        displayMode.includes(appMode.value)
      )
    );

    const handleSelectEntity = (entity: SelectEntity) => {
      emit('selectEntity', entity);
    };

    const closeGlobalNav = () => {
      if (isInactiveSubscription.value) return;
      setGlobalNavMenuOpen(false);
    };

    const assemblerStore = useAssemblerStore();

    const { sidebarCollapsed } = storeToRefs(assemblerStore);

    const showSearch = computed(
      () =>
        isContractRoomModuleActive.value && languageLoaded.value && !isInactiveSubscription.value
    );
    const toggleDocumentEditSidebar = () => {
      closeGlobalNav();
      assemblerStore.setSidebarCollapsed(isWindowSize(WindowSize.Small) && !sidebarCollapsed.value);
    };

    const logoLinkPath = computed(() =>
      isContractRoomModuleActive.value ? PathName.Dashboard : PathName.Rooms
    );
    const isContentLibTemplateEdit = computed(() => {
      const pathName: string = router.currentRoute.name;
      return (
        pathName === PathName.ContentLibraryEdit &&
        router.currentRoute.params.type === ResourceType.Template.toLowerCase()
      );
    });

    const showSideMenuSmallScreenIcon = computed(() => {
      const pathName: string = router.currentRoute.name;
      return (
        pathName === PathName.DocumentEdit ||
        pathName === PathName.Template ||
        isContentLibTemplateEdit.value
      );
    });

    return {
      PathName,
      IconSize,
      ModuleName,
      languageLoaded,
      sessionStore,
      handleSelectEntity,
      closeGlobalNav,
      toggleDocumentEditSidebar,
      toggleGlobalNavMenu,
      logoLinkPath,
      isContentLibTemplateEdit,
      showSideMenuSmallScreenIcon,
      isInactiveSubscription,
      showSearch,
      isMediumScreenAndDown,
      documentOptions,
      isGlobalNavMenuOpen,
      showValidateMyDocumentsEmailModal,
    };
  },
});
